import { render } from "./BaseAccordion.vue?vue&type=template&id=34e71226&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=34e71226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e71226"]])

export default __exports__